var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-556.000000, -115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-highlight",
    transform: "translate(556.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-marker_pen_filled",
    transform: "translate(7.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1325,10.04775 L0.07325,11.10675 C0.01075,11.169 -0.014,11.2595 0.00775,11.345 C0.0295,11.4305 0.0945,11.498 0.179,11.52325 L1.7525,11.9895 C1.776,11.9965 1.79975,12 1.8235,12 C1.88875,12 1.95275,11.97425 2.00025,11.92675 L2.50575,11.42125 L1.1325,10.04775 Z",
    id: "Path",
    fill: "#1495CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.32675,1.84225 L10.712,0.22775 C10.4995,0.0145 10.12375,-0.00075 9.88625,0.201 L2.8555,6.30875 L6.245,9.69825 L12.35525,2.6655 C12.55925,2.425 12.547,2.0635 12.32675,1.84225 Z",
    id: "Path",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49,6.6505 L1.6465,7.49375 C1.37475,7.766 1.479,8.0925 1.55525,8.33075 L1.59925,8.473 C1.70625,8.824 1.825,9.2165 1.47375,9.68225 L2.87475,11.08325 C3.077,10.9425 3.30075,10.8735 3.55275,10.8735 C3.763,10.8735 3.95025,10.9225 4.07425,10.95525 L4.14375,10.973 C4.18825,10.98375 4.232,10.99675 4.27475,11.0095 C4.392,11.044 4.513,11.0795 4.64175,11.0795 C4.80475,11.0795 4.9455,11.0215 5.05975,10.907 L5.903,10.06375 L2.49,6.6505 Z",
    id: "Path",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1495CD",
    x: 0,
    y: 11,
    width: 6,
    height: 1,
    rx: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteHighlight);
export default __webpack_public_path__ + "static/media/icon-rte-highlight.9941a83b48c5be30198dcc26affa9285.svg";
export { ForwardRef as ReactComponent };